// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1viBW","name":"ConsentHeader_name__1l3-7","birthday":"ConsentHeader_birthday__2Uqko","skeleton":"ConsentHeader_skeleton__1tRep"};